const updates = [
  {
    date: '2026.07.31',
    title: '暑期档重磅上新！多部热门大剧同步上线',
    desc: '《长风渡》《玉骨遥》《长相思》等暑期热播剧已全面更新至最新集，高清1080P画质，播放流畅不卡顿。',
    tag: '上新',
  },
  {
    date: '2026.07.28',
    title: '播放引擎全面升级，加载速度提升40%',
    desc: '技术团队完成核心播放引擎优化，视频加载更快、缓冲更少，无论WiFi还是移动网络都能流畅观看。',
    tag: '优化',
  },
  {
    date: '2026.07.25',
    title: '韩剧专区新增15部口碑热剧，限时追更',
    desc: '《黑暗荣耀》《财阀家的小儿子》《非常律师禹英禑》等高分韩剧全集上线，韩剧迷不可错过。',
    tag: '上新',
  },
  {
    date: '2026.07.20',
    title: '剧集分类页面改版，找剧更方便快捷',
    desc: '全新分类导航上线，按题材、地区、年代多维度筛选，快速定位想看的内容，追剧效率翻倍。',
    tag: '功能',
  },
  {
    date: '2026.07.15',
    title: '美剧《龙之家族》第二季全集中文上线',
    desc: 'HBO口碑巨制《龙之家族》第二季已完整上线，中文字幕同步更新，权游粉丝不容错过。',
    tag: '上新',
  },
  {
    date: '2026.07.10',
    title: '动漫频道扩容，热门番剧一网打尽',
    desc: '《鬼灭之刃》《咒术回战》《进击的巨人》等热门动漫全集上线，二次元追番首选。',
    tag: '上新',
  },
  {
    date: '2026.07.05',
    title: '手机端观看体验优化，支持画中画播放',
    desc: '移动端界面全面适配升级，新增画中画播放功能，边聊微信边追剧，体验更自由。',
    tag: '优化',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关注努努影院的最新剧集更新与平台动态，追剧不迷路
        </p>
        <div className="relative max-w-[760px] mx-auto">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>
          <div className="flex flex-col gap-6">
            {updates.map((item, index) => (
              <div key={index} className="relative flex gap-5">
                <div className="hidden sm:flex flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 text-primary-600 items-center justify-center text-xs font-bold z-10">
                  {index + 1}
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-5 border border-background-200">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                      item.tag === '上新' ? 'bg-primary-100 text-primary-700' : 
                      item.tag === '优化' ? 'bg-accent-100 text-accent-700' : 
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}